import { Trash2 } from "lucide-react";
import { EmptyState } from "./EmptyState";
import { PullToRefresh } from "./PullToRefresh";
import { TaskItem } from "./TaskItem";
import { TrashedTaskItem } from "./TrashedTaskItem";
import { useSyncStore } from "../stores/syncStore";
import { useTaskStore } from "../stores/taskStore";

export function TaskList() {
  const tasks = useTaskStore((s) => s.tasks);
  const filter = useTaskStore((s) => s.filter);
  const loadTasks = useTaskStore((s) => s.load);
  const loadSync = useSyncStore((s) => s.load);

  const onRefresh = async () => {
    await Promise.all([loadTasks(), loadSync()]);
  };

  const isTrashed = filter === "trashed";

  if (!tasks.length) {
    return (
      <PullToRefresh onRefresh={onRefresh}>
        <div className="flex h-full min-h-[60vh] flex-col items-center justify-center px-8 pb-8">
          {isTrashed ? (
            <>
              <Trash2 className="h-10 w-10 text-dim" />
              <p className="mt-3 text-sm text-muted dark:text-muted-dark">
                ゴミ箱は空です
              </p>
            </>
          ) : (
            <EmptyState />
          )}
        </div>
      </PullToRefresh>
    );
  }

  return (
    <PullToRefresh onRefresh={onRefresh}>
      <div className="flow-scrollbar space-y-2 px-8 pb-8">
        {isTrashed
          ? tasks.map((task) => <TrashedTaskItem key={task.id} task={task} />)
          : tasks.map((task) => <TaskItem key={task.id} task={task} />)}
      </div>
    </PullToRefresh>
  );
}
